import React, { Component } from "react";
import { withStyles, withTheme } from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";

const styles = theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = ["2021", "2022", "2023"];

class MultipleSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      personName: props.initialValue ? [props.initialValue] : [],
    };
  }

  handleChange = event => {
    const { value } = event.target;
    this.setState({ personName: value });
    this.props.filter(value,this.props.label );
  };

  handleClear = () => {
        this.setState({ personName: [] });

  };

  render() {
    const { classes, theme } = this.props;
    const { personName } = this.state;
    const optionsToUse = this.props.options && this.props.options.length > 0 ? this.props.options : names;

    return (
      <div>
        <FormControl className={classes.formControl}>
          <InputLabel id={`${this.props.id || "select-chip"}-label`}>{this.props.label}</InputLabel>
          <Select
            labelId={`${this.props.id || "select-chip"}-label`}
            id={this.props.id || "select-chip"}
            multiple
            value={personName}
            onChange={this.handleChange}
            input={<Input id="select-multiple-chip" />}
            renderValue={selected => (
              <div className={classes.chips}>
                {selected.map(value => (
                  <Chip key={value} label={value} className={classes.chip} />
                ))}
              </div>
            )}
            MenuProps={MenuProps}>
            {optionsToUse.map(name => (
              <MenuItem
                key={name}
                value={name}
                style={{ fontWeight: personName.indexOf(name) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium }}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    );
  }
}

export default withStyles(styles)(withTheme(MultipleSelect));
